import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { Link } from "@tanstack/react-router"
import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./AccountItem.module.scss"
import { AccountReading } from "./AccountReading"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import {
  followToSharer,
  followToSharerInitials,
} from "src/utils"

interface Props extends ComponentPropsWithoutRef<"a"> {
  follow: Follow;
}

export const AccountItem = forwardRef<HTMLAnchorElement, Props>(
  function AccountItem(props: Props, ref: Ref<HTMLAnchorElement>) {
    const {
      follow,
      ...htmlProps
    } = props

    const { currentFollow } = useFollowedUsers()
    const selected = currentFollow.id === follow.id

    const className = classNames(
      styles.container,
      htmlProps.className,
      selected && styles.selectedUser,
    )

    const polyglot = usePolyglot()

    return (
      <Link
        {...htmlProps}
        className={className}
        to={follow.is_self ? "/home" : "/home/$accountId"}
        params={follow.is_self ? {} : { accountId: follow.following_account_id }}
        ref={ref}
        id="account-summary-link"
      >
        <div className={styles.nameAndIconContainer}>
          <div className={styles.userInitial}>
            {followToSharerInitials(follow)}
          </div>
          <div className={styles.userText}>
            <div
              className={styles.userName}
              id="nickname"
            >
              {followToSharer(follow)}
            </div>
            {selected && (
              <div className={styles.selectedUserText}>
                {polyglot.t("components.navigation_menu.selected_user")}
              </div>
            )}
          </div>
        </div>
        <AccountReading accountId={follow.following_account_id} />
      </Link>
    )
  },
)
